export default __webpack_public_path__ + "static/media/edit_icn.1f354b26.svg";